/**
 * SKU Cart - ZOZO-style per-SKU add-to-cart buttons
 * Handles: mobile bottom-sheet modal, Flickity carousel sync, Swym wishlist,
 * and AJAX cart add via /cart/add.js (cart.js API).
 */
(function () {
  'use strict';

  /* ========================================================
   * 1. Mobile SKU modal (bottom sheet)
   * ======================================================== */

  function initMobileSkuModal() {
    var modal = document.querySelector('.js-sku-modal');
    if (!modal) return;

    document.querySelectorAll('.js-open-sku-modal').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.js-close-sku-modal').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    var mql = window.matchMedia('(min-width: 1000px)');
    function handleResize(e) {
      if (e.matches && modal.classList.contains('is-active')) {
        closeModal();
      }
    }
    if (mql.addEventListener) {
      mql.addEventListener('change', handleResize);
    } else if (mql.addListener) {
      mql.addListener(handleResize);
    }
  }

  /* ========================================================
   * 2. Color-image → carousel sync (Focal theme Flickity)
   * ======================================================== */

  function initColorSelectButtons() {
    document.querySelectorAll('.js-color-select').forEach(function (button) {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';

      button.addEventListener('click', function () {
        var mediaId = this.dataset.mediaId;
        if (!mediaId) return;

        // Strategy 1: Find and click the theme's existing thumbnail button
        var thumbnailBtn = document.querySelector(
          '.product__thumbnail-item[data-media-id="' + mediaId + '"]'
        );
        if (thumbnailBtn) {
          thumbnailBtn.click();
          return;
        }

        // Strategy 2: Find the slide directly and select via Flickity
        var slide = document.querySelector(
          '.product__media-item[data-media-id="' + mediaId + '"]'
        );
        if (!slide) return;

        var carousel = slide.closest('flickity-carousel');
        if (!carousel) return;

        var visibleSlides = carousel.querySelectorAll('.product__media-item:not(.is-filtered)');
        var slideIndex = -1;
        for (var i = 0; i < visibleSlides.length; i++) {
          if (visibleSlides[i] === slide) {
            slideIndex = i;
            break;
          }
        }
        if (slideIndex === -1) return;

        var flkty = null;
        if (carousel.flickityInstance) {
          flkty = carousel.flickityInstance;
        } else if (typeof Flickity !== 'undefined') {
          flkty = Flickity.data(carousel);
        }
        if (flkty) {
          flkty.select(slideIndex);
        }
      });
    });
  }

  /* ========================================================
   * 3. AJAX Add to Cart via /cart/add.js
   * ======================================================== */

  function initSkuAddToCart() {
    document.querySelectorAll('.js-sku-add-to-cart').forEach(function (btn) {
      if (btn.dataset.cartInitialized === 'true') return;
      btn.dataset.cartInitialized = 'true';

      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        // Build payload
        var body = {
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: 'mini-cart'
        };

        // Disable button while request is in flight
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');

        var cartAddUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartAddUrl)
          ? window.themeVariables.routes.cartAddUrl
          : '/cart/add';

        var cartUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl)
          ? window.themeVariables.routes.cartUrl
          : '/cart';

        fetch(cartAddUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        })
          .then(function (response) {
            return response.json().then(function (json) {
              return { ok: response.ok, data: json };
            });
          })
          .then(function (result) {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-busy');

            if (result.ok) {
              // Redirect to cart page
              window.location.href = cartUrl;
              return;
            }

            // Show cart notification on error
            btn.dispatchEvent(new CustomEvent('cart-notification:show', {
              bubbles: true,
              cancelable: true,
              detail: {
                status: 'error',
                error: result.data['description'] || ''
              }
            }));
          })
          .catch(function () {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-busy');
          });
      });
    });
  }

  /* ========================================================
   * 4. Swym wishlist (optional)
   * ======================================================== */

  function waitForSwym(callback, maxRetries) {
    maxRetries = maxRetries || 50;
    var retries = 0;

    var interval = setInterval(function () {
      retries++;
      if (window._swat && window.SwymPageData) {
        clearInterval(interval);
        callback();
      } else if (retries >= maxRetries) {
        clearInterval(interval);
      }
    }, 100);
  }

  function initFavoriteButtons() {
    if (!window._swat) return;

    var buttons = document.querySelectorAll('.c_wishlist__button');
    if (!buttons.length) return;

    _swat.fetchWrtEventTypeET(function (wishlist) {
      var wishIds = {};
      wishlist.forEach(function (item) {
        wishIds[item.epi] = item;
      });

      buttons.forEach(function (btn) {
        var epi = parseInt(btn.dataset.variantId, 10);
        if (wishIds[epi]) {
          btn.classList.add('is-saved');
        }

        if (btn.dataset.initialized === 'true') return;
        btn.dataset.initialized = 'true';

        btn.addEventListener('click', function (e) {
          e.preventDefault();

          var product = {
            epi: epi,
            empi: parseInt(btn.dataset.productId, 10),
            du: btn.dataset.productUrl || window.location.href
          };

          if (btn.classList.contains('is-saved')) {
            _swat.removeFromWishList(product, function () {
              btn.classList.remove('is-saved');
            });
          } else {
            _swat.addToWishList(product, function () {
              btn.classList.add('is-saved');
            });
          }
        });
      });
    });
  }

  /* ========================================================
   * 5. Initialization
   * ======================================================== */

  function init() {
    initMobileSkuModal();
    initColorSelectButtons();
    initSkuAddToCart();

    waitForSwym(function () {
      initFavoriteButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('variant:changed', function () {
    setTimeout(function () {
      initFavoriteButtons();
    }, 100);
  });

})();
